//@flow
import * as React from 'react'
import { connect } from 'react-redux';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpandMore from '@material-ui/icons/ExpandMore'
import Typography from '@material-ui/core/Typography'
import PanelSpace from '../../views/ProjectGorgon/common/PanelSpace'
import * as actions from '@lesofi/phoenix-sdk-js/lib/genericReducer/actions'

type ExpandPanelContainer$PropsType = {
    generic: any,
    actionType: string,
    disabled: boolean,
    fieldError: ?any,
    title: string,
    formPanels: Array<string>,
    children: ?any,
    elementId: string,
    visible?: boolean
}

const styles = ({
    heading: {
        fontSize: 15,
        fontWeight: 500
    },
    headingError: {
        fontSize: 15,
        fontWeight: 700,
        color: 'red'
    }
})

const handlePanelOnChange=(event:any,expanded:boolean,props:any,panel:any)=>{
    if (expanded){
        props.addFormExpandablePanel(panel)
    }else {
        props.removeFormExpandablePanel(panel)
    }
}

const displayFieldRequireMsg=(noOfErrors:any)=>{
    if (noOfErrors > 0) {
        return ` : *${noOfErrors} ${noOfErrors == 1?'field is mandatory!':'fields are mandatory!'}`
    }else {
        return ''
    }
}

const ExpandPanelContainer=(props:any)=>{
    const { formPanels,actionType,visible } = props
    const canRender = typeof visible=='undefined'?true:(visible:any)
    
    let elements = []
    
    let firstElement = (
        <div className='row' key={`PanelHeader${props.elementId}`}>
            <div className="col-sm">
                <ExpansionPanel onChange={(e,expanded)=> handlePanelOnChange(e,expanded,props,actionType)} disabled={props.disabled}  >
                    <ExpansionPanelSummary expandIcon={<ExpandMore />}>
                        <Typography style={props.fieldError?styles.headingError:styles.heading} >{props.title} {displayFieldRequireMsg(props.fieldError)}</Typography>
                    </ExpansionPanelSummary>
                </ExpansionPanel>
            </div>
        </div>
    )
    if (canRender){
        elements.push(firstElement)
    }
    
    if (canRender && formPanels.length > 0 && formPanels.indexOf(actionType)>=0){
        const secondElement = (
            <div className='row' key={`PanelDetail${props.elementId}`}>
                <div className="col-sm">
                    {props.children}
                </div>
            </div>
        )
        elements.push(secondElement)
    }

    if (canRender){
        elements.push(<PanelSpace key={`PanelSpace${props.elementId}`} />)
    }
    
    return elements
}

const mapStateToProps:any = (state, ownProps) => {
    return {
        generic: state.generic
    }
}

const mapDispatchToProps:any = (dispatch, ownProps) => {
    return {
        addFormExpandablePanel: (panel)=> {
            dispatch(actions.addFormExpandablePanel(panel))    
        },
        removeFormExpandablePanel: (panel)=> {
            dispatch(actions.removeFormExpandablePanel(panel))    
        }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ExpandPanelContainer);


// WEBPACK FOOTER //
// ./src/components/phoenixComponents/ExpandPanelContainer.js